import { render, staticRenderFns } from "./comercial.vue?vue&type=template&id=1773798f&scoped=true"
import script from "./comercial.vue?vue&type=script&lang=js"
export * from "./comercial.vue?vue&type=script&lang=js"
import style0 from "./comercial.vue?vue&type=style&index=0&id=1773798f&prod&lang=css"
import style1 from "./comercial.vue?vue&type=style&index=1&id=1773798f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1773798f",
  null
  
)

export default component.exports